module.exports = __webpack_public_path__ + "media/images/right-arrow-button-white-79bd02c8390d095e3fdf5befd67f8564.svg";